export function prettyRedeemError(code: string): string {
  switch (code) {
    case 'invalid_pin':
      return 'PIN does not match.';
    case 'code_expired':
      return 'This code has expired.';
    case 'already_redeemed':
      return 'This code was already redeemed.';
    case 'not_transferable':
      return 'This code is not transferable — only the original buyer may redeem.';
    case 'placement_not_allowed':
      return 'You cannot place a slot under that anchor.';
    case 'sponsor_not_found':
      return 'Affiliate code not recognized.';
    case 'sponsor_has_no_active_slot':
      return 'The sponsor has no active slot to attach to.';
    case 'anchor_not_active':
      return 'Anchor slot is not active.';
    case 'side_required':
      return 'Choose left or right when an anchor is specified.';
    case 'not_your_lead':
      return 'That member is not one of your affiliates.';
    case 'not_your_direct_downline':
      // Name the alternative: transferring the code is one tab away in the same
      // Code Vault, reaches any depth, and activates them under their OWN
      // registered sponsor instead of moving them onto yours.
      return 'You can only activate your direct affiliates. To help someone deeper in your team, transfer the code to them instead — it will activate under their own sponsor.';
    case 'lead_inactive':
      return 'That member is not an active account.';
    case 'recipient_not_found':
      return 'No member matches that email.';
    case 'recipient_username_mismatch':
      return 'That username does not match the account for that email.';
    case 'max_slots_exceeded':
      return 'That member has reached the maximum number of slots allowed.';
    case 'code_not_in_your_vault':
      return 'You can only use codes from your own Code Vault.';
    case 'code_only_for_upgrade':
      return 'This code can only upgrade an existing slot, not activate a new one.';
    case 'activation_terms_not_accepted':
      return 'Please accept the activation terms to continue.';
    case 'activation_terms_version_mismatch':
      return 'The activation terms have changed — please review and accept again.';
    case 'recruit_membership_not_allowed':
      return 'Your membership is not allowed to recruit this package. Ask your sponsor or admin about eligible packages.';
    case 'membership_binary_locked':
      return 'This package cannot be placed in the binary tree — the slot will activate without a binary position.';
    default:
      return code;
  }
}
